import { render, staticRenderFns } from "./CampoFormulario.vue?vue&type=template&id=410cab14&scoped=true"
import script from "./CampoFormulario.vue?vue&type=script&lang=js"
export * from "./CampoFormulario.vue?vue&type=script&lang=js"
import style0 from "./CampoFormulario.vue?vue&type=style&index=0&id=410cab14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410cab14",
  null
  
)

export default component.exports